







import { Component, Vue } from 'vue-property-decorator'
@Component
export default class ReconciliationDetail extends Vue{

}
